import { render } from "./index.vue?vue&type=template&id=64d1e93c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=64d1e93c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64d1e93c"

export default script